import {IEnvironment} from './environment.interface';

export const environment: IEnvironment = {
  envName: 'production',
  dynatraceUrl: 'https://js-cdn.dynatrace.com/jstag/147f273fa2a/bf63206omp/a5ac3cb1030f22f1_complete.js',
  production: true,
  apiPath: 'https://api.vspglobal.com',
  acsUrl: 'https://api.eyefinity.com',
  showBuildNumbers: false,
  authConfig: {
    issuer: 'https://api.eyefinity.com',
    clientId: 'vsp-retail',
    scopes: [
      'auth_retail',
      'openid',
      'profile',
      'read:retail',
      'write:retail',
      'member_view',
      'provider_view',
      'claim_view',
      'eligibility_view',
      'write:claim',
      'write:eligibility',
      'client_view',
      'read:vc.vsr',
      'write:vc.vsr',
      'product_view',
      'read:vc.patientencounter',
      'write:vc.patientencounter',
      'read:vc.affiliatespectaclelens',
      'read:vc.eligibility.vsr_link',
      'read:vc.eligibility.service_type',
      'read:vc.doctorclaimreport',
      'read:vc.eligibility.additional_auth_override',
      'write:vc.vsr_overrides'
    ],
    redirectUri: 'https://2020source.eyefinity.com'
  },
  showPageSummary: false,
  sessionConfig: {
    idle: 1800,
    timeout: 30
  }
};
